export default "__VITE_ASSET__D1Xpqrzn__"